<template>
  <div class="expired-basket-item p-1">
    <div class="row">
      <div class="col-8">
        <h5>
          {{ value.date | formatDate }} ({{ value.products.length }}
          {{ "Item" | inflect(value.products.length) }})
        </h5>
      </div>
      <div class="col-4 text-right">
        <b-button size="sm">Restore</b-button><br />
        <b-button
          variant="link"
          size="sm"
          v-b-toggle="'expired-products-' + _uid"
        >
          <span class="when-closed">View Items</span>
          <span class="when-open">Hide Items</span>
        </b-button>
      </div>
    </div>
    <b-collapse :id="'expired-products-' + _uid" class="mt-1">
      <div v-for="(product, index) in value.products" :key="index" class="row">
        <div class="col-2 align-self-center">
          <img :src="product.img" :alt="product.title" class="img-fluid" />
        </div>
        <div class="col-10 align-self-center">
          <h6>{{ product.title }}</h6>
          <p>Quantity: {{ product.quantity }}</p>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
  },
};
</script>